import React, { useEffect, useState } from 'react';

import './styles.css';

import close from '../../../assets/images/close.svg';
import statistics from '../../../assets/images/statistics.svg';
import pin3 from '../../../assets/images/pin3.svg';
import { Row, Col } from 'react-bootstrap';
import api from '../../../services/api';
import moment from "moment";
import 'moment/locale/pt-br';
import { ContinuousColorLegend } from 'react-vis';

export const ModalCheckins = ({ handleClose, title, id, type, totalCheckins, filter }) => {
  const [checkins, setCheckins] = useState([]);
  useEffect(() => {
    getCheckins();
  }, []);


  const getCheckins = async () => {
    const { data } = await api.get(`${type}/${id}/checkins`, {
      params: filter
    });
    setCheckins(data.checkins);
  }
  return (
    <div className="dash-modal">
      <div className="dash-modal-content lg">
        <button className="btn-close" onClick={() => handleClose()}><img src={close} /></button>
        <div className="dash-modal-header header-modal-pages">
          <div>
            <img src={statistics} />
            <h1>Estatísticas</h1>
          </div>
          <div className="data-about">
            <img src={pin3} />
            <h1>{totalCheckins}</h1>
            <p>{title}</p>
          </div>
        </div>
        <div className="dash-modal-body">
          <div className="box-card h-full">
            <div className="box-card-noPadding box-table-shifts" id="lastOrange">
              <table className="table-dash">
                <thead>
                  <tr className="light-blue">
                    <th>Dia</th>
                    <th>Plantão</th>
                    <th>Corretores</th>
                    <th>Check-in</th>
                    <th>Check-out</th>
                  </tr>
                </thead>
                <tbody>
                  {checkins.map((checkin, key) => (
                    <tr key={key}>
                      <td>{moment(checkin.checkin).format("DD/MM/YYYY")}</td>
                      <td>{checkin.plantao.imovel_nome}</td>
                      <td>{checkin.corretor.apelido}</td>
                      <td>{moment(checkin.checkin).format("HH:mm")}</td>
                      <td>{checkin.checkout ? moment(checkin.checkout).format("HH:mm") : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="dash-modal-footer">

        </div>
      </div>
    </div>
  );

}

export default ModalCheckins;